import { useCallback, useState } from 'react';

export default function useFieldFormPopup<FieldValueType>(
  initialValue: FieldValueType,
  onSave: (value: FieldValueType) => void
) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // The following state holds the value in modal, not the actual field's value.
  // If/when the modal is saved, this value is commited to the field through `onSave` callback.
  const [currentValue, setValue] = useState<FieldValueType>(initialValue);
  const resetValue = useCallback(() => setValue(initialValue), [initialValue]);

  const toggleModal = useCallback(() => {
    // Reset state of the subform when the modal toggles
    resetValue();
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen, resetValue]);

  const handleSave = useCallback(() => {
    onSave(currentValue);
    setIsOpen(false);
  }, [onSave, currentValue]);

  return {
    isOpen,
    currentValue,
    setValue,
    toggleModal,
    onSave: handleSave,
  };
}
